import { Component, OnInit ,ViewChild} from '@angular/core';
import { NgForm } from "@angular/forms";
import { DateAdapter } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from "@angular/common";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LoanapprovallevelService } from "../shared/loanapprovallevel.service";
import { LoanschemeService } from "../shared/loanscheme.service";

@Component({
  selector: 'app-loanapprovallevel',
  templateUrl: './loanapprovallevel.component.html',
  styleUrls: ['./loanapprovallevel.component.css']
})
export class LoanapprovallevelComponent implements OnInit {

  AddButtonText: string;
  ErrorText: string;
  dataSourceList = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  divDetails: boolean;
  ParentApprovalNo: number;
  LoanTypeList: [''];
  LoanCategoryList:[''];
  PeriodTypeList:[''];
  LoanSchemeList:[''];
  ApprovalLevelList:[''];

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
     public loanapprovallevelService: LoanapprovallevelService,
     public loanschemeService:LoanschemeService) { }

  ngOnInit() { 
    
    this.activatedRoute.params.subscribe(param => {
    this.ParentApprovalNo = + param['Id'];  //Parent Group Id
  });

  this.divDetails = true;

  this.GetLoanCategoryList();
  this.GetLoanTypeList();
  this. GetPeriodTypeList();
  this. GetLoanSchemeList();
  this.GetApprovalLevelList();
  this.resetForm();
  
  this.dataSourceList.paginator = this.paginator;

  if (Number.isNaN(this.ParentApprovalNo)) {
    this.loanapprovallevelService.selectedLoanapprovallevel.Id = 0;
    this.loanapprovallevelService.selectedLoanapprovallevel.Flag = 1;
    this.loanapprovallevelService.selectedLoanapprovallevel.IsActive = 1;
    this.AddButtonText = "Save";
  }
  else {
    this.loanapprovallevelService.selectedLoanapprovallevel.Id = +this.ParentApprovalNo;
    this.loanapprovallevelService.selectedLoanapprovallevel.Flag = 2;
    this.AddButtonText = "Edit & Save";

    this.GetloanapprovallevelById();
  }

}


resetForm(form?: NgForm) {
  if (form != null)
    form.reset();

  this.loanapprovallevelService.selectedLoanapprovallevel = {
    Id : null,
    LoanTypeId: 1,
    LoanCategoryId: 0,
    LoanSchemeId: 0,
    ApprovalLevelId: 0,
    MinValue: null,
    MaxValue: null,
    RoleId: 0,
    ApprovalEmployeeId: 0,
    CompanyId: null,
    EmployeeBranchId: null,
    EmployeeId: null,
    SaasId: null,
    CreatedDate: null,
    ModifiedDate: null,
    IsActive: null,
    Flag: 0,
  }
}

public onSubmit(form: NgForm) {
  this.loanapprovallevelService.IUDLoanApprovalLevel(form.value)
    .toPromise()
    .then(data => {
      this.resetForm(form);
      this.router.navigate(['/loanapprovallevellist']);
    })
    .catch(err => { console.log(err) });
}

GetloanapprovallevelById() {

  if (!Number.isNaN(this.ParentApprovalNo)) {
    this.loanapprovallevelService.selectedLoanapprovallevel.Id = this.ParentApprovalNo;
    this.loanapprovallevelService.FetchLoanApprovalLevelById(this.loanapprovallevelService.selectedLoanapprovallevel).subscribe(data => {
      this.loanapprovallevelService.selectedLoanapprovallevel = data;
      this.loanapprovallevelService.selectedLoanapprovallevel.Flag = 2;
    })
  }
}

GetLoanTypeList() {
  this.loanschemeService.FetchLoanType().subscribe(data => {
    this.LoanTypeList = data;
  })
}

GetLoanCategoryList() {
  this.loanschemeService.FetchLoanCategory().subscribe(data => {
    this.LoanCategoryList = data;
  })
}

GetPeriodTypeList() {
  this.loanschemeService.FetchPeriodType().subscribe(data => {
    this.PeriodTypeList = data;
  })
}

GetLoanSchemeList() {
  this.loanschemeService.FetchLoanSchemeList().subscribe(data => {
    this.LoanSchemeList = data;
  })
}

GetApprovalLevelList() {
  this.loanapprovallevelService.FetchApprovalLevel().subscribe(data => {
    this.ApprovalLevelList = data;
  })
}

}
